export default "__VITE_ASSET__d442e216__"